export * from './additional-setting-page/additonal-setting-page.view';
export * from './edit-label/edit-label.view';
export * from './button-config/button-config.view'
export * from './calendar-template/calendar-template.view'
export * from './rules-validations/rules-validations.view';
export * from './setting.view';